class SpeshProductFacts extends HTMLElement {
  connectedCallback() {
    this.variantData = this.getVariantData();
    this.form = document.querySelector('.js-product-form');
    if (!this.form || !this.variantData.length) return;

    this.onChange = this.onChange.bind(this);
    this.form.addEventListener('change', this.onChange);
    document.addEventListener('variant:changed', this.onChange);
    this.update();
  }

  disconnectedCallback() {
    if (this.form) this.form.removeEventListener('change', this.onChange);
    document.removeEventListener('variant:changed', this.onChange);
  }

  getVariantData() {
    const node = document.querySelector('[id^="all-variant-data-"]');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent);
    } catch (_error) {
      return [];
    }
  }

  onChange() {
    window.requestAnimationFrame(() => this.update());
  }

  update() {
    const input = this.form.querySelector('input[name="id"]');
    const variant = this.variantData.find((item) => String(item.id) === String(input?.value));
    if (!variant) return;

    const price = this.querySelector('[data-spesh-current-price]');
    const comparison = this.querySelector('[data-spesh-comparison-price]');
    const savings = this.querySelector('[data-spesh-proof-savings]');
    if (price) price.textContent = this.formatMoney(variant.price);
    if (comparison) comparison.textContent = this.formatMoney(variant.compare_at_price || variant.price);
    if (savings) {
      const percent = variant.compare_at_price > variant.price
        ? Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100)
        : 0;
      savings.textContent = `${percent}%`;
    }

    const contextSavings = document.querySelector('[data-spesh-savings]');
    if (contextSavings && variant.compare_at_price > variant.price) {
      const difference = variant.compare_at_price - variant.price;
      if (contextSavings.dataset.speshSavingsFormat === 'currency') {
        contextSavings.textContent = this.formatMoney(difference);
      } else {
        const percent = Math.round((difference / variant.compare_at_price) * 100);
        contextSavings.textContent = `${percent}%`;
      }
    }
  }

  formatMoney(cents) {
    if (window.Shopify?.formatMoney && window.theme?.money_product_price_format) {
      return window.Shopify.formatMoney(cents, window.theme.money_product_price_format);
    }
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(cents / 100);
  }
}

if (!customElements.get('spesh-product-facts')) {
  customElements.define('spesh-product-facts', SpeshProductFacts);
}
